import { render, staticRenderFns } from "./ManagePropertiesView.vue?vue&type=template&id=ab33a6a4&"
import script from "./ManagePropertiesView.vue?vue&type=script&lang=js&"
export * from "./ManagePropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports